
import axios from "axios";
import React, { useState } from 'react';
import styled from "styled-components";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';


const StyledAutocomplete = styled(Autocomplete)`
  .MuiTextField-root {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export default function DaDataINNAutocomplete({value, onChange, textFieldProps}) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleChange = (e, value) => {
    onChange(value);
    setOptions([]);
  };

  const loadOptions = async (search) => {
    if (/^-?\d+$/.test(search) && search.length >= 10) {
      setLoading(true);
      let results = [];
      const load = async () => {
        return axios.get('dadata-suggestion-inn', {
          params: {query: search}
        }).then(res => {
          res.data.suggestions.forEach(result => {
            results.push({
              name: result.value,
              inn: result.data.inn,
              kpp: result.data.kpp,
              address: result.data.address?.value,
              head_name: result.data.management?.name,
              head_post: result.data.management?.post,
            })
          })
        });
      };

      await load();

      setLoading(false);
      setOptions(results);
    }
  };

  const handleInputBlur = (e, value) => {
    onChange(e.target.value);
  }

  const handleInputChange = (e, value, reason) => {
    if (reason === 'input') {
      loadOptions(value);
    }
  }

  const getOptionLabel = (option) => {
    return typeof option === 'string' ? option : option['name']
  }

  return (
    <StyledAutocomplete
      freeSolo
      options={options}
      loading={loading}
      value={value}
      noOptionsText={'Ничего не найдено'}
      loadingText={'Поиск контрагента по ИНН...'}
      selectOnFocus={true}
      getOptionLabel={getOptionLabel}
      autoHighlight={false}
      autoComplete={true}
      filterOptions={(options, state) => options}
      onInputChange={handleInputChange}
      onChange={(e, newValue) => handleChange(e, newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          margin="normal"
          multiline={true}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            value: value
          }}
          {...textFieldProps}
          onBlur={(e) => handleInputBlur(e)}
          onChange={(e) => handleInputBlur(e)}
        />
      )}
    />
  )
}

